import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LcsApiService } from '@lcs/shared/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { GetUserDetail, GetUserDetailVariables } from '../../user-details/queries/generated/GetUserDetail';
import { getUserDetail } from '../../user-details/queries/user-detail.graphql';
import * as UserPreferenceDetailActions from './user-preference-detail.actions';

@Injectable()
export class UserPreferenceDetailEffects {
   loadUserDetails$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(UserPreferenceDetailActions.loadCurrentUserId),
         switchMap((user) => {
            if (user.userId === null) {
               return EMPTY;
            }

            return this.apiService
               .query<GetUserDetail, GetUserDetailVariables>({
                  query: getUserDetail,
                  variables: { id: user.userId },
               })
               .pipe(
                  map((response) => UserPreferenceDetailActions.loadUserSuccess({ user: response.data.user })),
                  catchError((error) => of(UserPreferenceDetailActions.loadUserFailure(error)))
               );
         })
      );
   });

   saveUserPreferenceSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(UserPreferenceDetailActions.saveUserPreferenceDetailSuccess),
            tap(() => {
               this.snackbar.open('User Preferences Saved');
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private apiService: LcsApiService,
      private store: Store,
      private snackbar: MatSnackBar
   ) {}
}
